import { useQuery } from '@fv/client-core'
import type { RouteGuideExecutionView } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

export const routeGuideKeys = {
  execution: (loadId: string) => ['route-guide-execution', loadId] as const,
}

export function useRouteGuideExecution(
  loadId?: string,
  options?: { enabled?: boolean },
) {
  return useQuery(
    routeGuideKeys.execution(loadId ?? ''),
    () =>
      shipperFetch<RouteGuideExecutionView | null>(
        `/route-guides/executions/${loadId}`,
      ),
    {
      enabled: !!loadId && options?.enabled !== false,
    },
  )
}
